import {
  CIVILBUDGETSCHEDULE_LOADING,
  GET_CIVILBUDGETSCHEDULE,
  GET_CIVILBUDGETSCHEDULE_SUCCESS,
  GET_CIVILBUDGETSCHEDULE_FAIL,
  ADD_CIVILBUDGETSCHEDULE_SUCCESS,
  ADD_CIVILBUDGETSCHEDULE_FAIL,
  DELETE_CIVILBUDGETSCHEDULE_SUCCESS,
  DELETE_CIVILBUDGETSCHEDULE_FAIL,
  UPDATE_CIVILBUDGETSCHEDULE_SUCCESS,
  UPDATE_CIVILBUDGETSCHEDULE_FAIL,
  CIVILBUDGETSCHEDULE_RESET
} from "./actionType";

const INIT_STATE = {
  civilBudgetSchedules: [],
  error: {},
};

const CivilBudgetSchedule = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILBUDGETSCHEDULE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETSCHEDULE:
          return {
            ...state,
            civilBudgetSchedules: action.payload.data,
            isCivilBudgetScheduleCreated: false,
            isCivilBudgetScheduleSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILBUDGETSCHEDULE_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETSCHEDULE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilBudgetScheduleCreated: false,
            isCivilBudgetScheduleSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILBUDGETSCHEDULE: {
      return {
        ...state,
        isCivilBudgetScheduleCreated: false,
        loading: true,
      };
    }

    case CIVILBUDGETSCHEDULE_LOADING: {
      return {
        ...state,
        isCivilBudgetScheduleCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILBUDGETSCHEDULE_SUCCESS:
      return {
        ...state,
        isCivilBudgetScheduleCreated: true,
        loading: false,
        civilBudgetSchedules: [action.payload.data, ...state.civilBudgetSchedules],
      };

    case ADD_CIVILBUDGETSCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILBUDGETSCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetSchedules: state.civilBudgetSchedules.filter(
          civilCivilBudgetSchedule => civilCivilBudgetSchedule.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILBUDGETSCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILBUDGETSCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetSchedules: state.civilBudgetSchedules.map(civilCivilBudgetSchedule =>
          civilCivilBudgetSchedule.id.toString() === action.payload.data.id.toString() ? { ...civilCivilBudgetSchedule, ...action.payload.data } : civilCivilBudgetSchedule
        ),
      };

    case UPDATE_CIVILBUDGETSCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILBUDGETSCHEDULE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilBudgetSchedule;